import { alpha } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

import MarkerVectorLayerV2 from '../../../../../../shared/ui/GeoMap/MarkerVectorLayerV2';

const createLocationSrcIcon = (color) => {
  const svgString = `
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C7.8 2 4 5.22 4 10.2C4 13.38 6.45 17.12 11.34 21.43C11.72 21.76 12.29 21.76 12.67 21.43C17.55 17.12 20 13.38 20 10.2C20 5.22 16.2 2 12 2Z" fill="${color}" stroke="white"/>
  </svg>
  `;
  const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
  return URL.createObjectURL(svgBlob);
};

// Иконка для стартового/финишного маркера
const createStartEndSrcIcon = (color) => {
  const svgString = `
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="${color}" rx="4" stroke="white" />
  </svg>
  `;
  const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
  return URL.createObjectURL(svgBlob);
};

export default function Marker({ selected, orderNumber, count, color, startIcon, endIcon, ...other }) {
  const isSelected = selected?.includes(orderNumber);
  const src = React.useMemo(
    () => (isSelected ? createLocationSrcIcon(color) : startIcon || endIcon ? createStartEndSrcIcon(color) : null),
    [color, isSelected, startIcon, endIcon],
  );
  return (
    <MarkerVectorLayerV2
      zIndex={isSelected ? 12 : 11}
      src={src}
      color={!selected?.length || isSelected || count < 5 ? color : alpha(color, 0.6)}
      isChangeable={isSelected}
      selected={isSelected}
      {...other}
    />
  );
}
Marker.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  orderNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  count: PropTypes.number,
  color: PropTypes.string.isRequired,
  startIcon: PropTypes.bool,
  endIcon: PropTypes.bool,
};
Marker.defaultProps = {
  count: 0,
  startIcon: false,
  endIcon: false,
};
